import Swiper from "swiper";
import { EffectFade, Navigation, Pagination } from "swiper/modules";

const blockquoteSponsorsEls = document.querySelectorAll(".blockquote-sponsors");
blockquoteSponsorsEls?.forEach((el) => {
  new Swiper(el.querySelector(".swiper-container"), {
    modules: [Navigation, Pagination, EffectFade],
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoHeight: true,
    pagination: {
      el: el.querySelector(".blockquote-sponsors__pagination"),
      type: "fraction",
    },
    navigation: {
      nextEl: el.querySelector(".blockquote-sponsors__button-next"),
      prevEl: el.querySelector(".blockquote-sponsors__button-prev"),
    },
  });
});
